import React, { useMemo } from 'react';
import { useStores } from '../../../store';
import { Address } from '../../../../dtos/version.dto';
import { addressGroupFullDataInfo, listCells } from '../inventory-utils';

interface AddressGroupCellProps {
    addressData: Address;
}

export const AddressGroupCell: React.FC<AddressGroupCellProps> = ({ addressData }) => {
    const {fwVersionStore} = useStores();

    const addressGroups = useMemo(() => {
        return fwVersionStore.selectedVersionAddressGroupsByAddress(addressData);
    }, [addressData]);

    return useMemo(() => listCells(addressGroups, 'address-group', addressGroupFullDataInfo(addressGroups, fwVersionStore.getAddresses)),
        [addressGroups]);
};
